import React from 'react'
import './Banner.css'
import { Carousel } from 'antd'
// import { useNavigate } from "react-router";
import img_bg1 from '../../../img/bg1.png'
import img_bg2 from '../../../img/bg2.png'
import img_bg3 from '../../../img/bg3.png'
import img_bg4 from '../../../img/bg4.png'
import getNum from '../../../method/method'
import starsScore from '../../../method/start'

export default function Banner({ hotgame }) {
  //   const navigate = useNavigate();
  /* console.log(hotgame); */

  /* 轮播背景 */
  const backbg = [img_bg1, img_bg2, img_bg3, img_bg4]

  /* 轮播遍历 */
  const res = target => {
    let nar = []
    for (var i = 0; i < target?.length; i += 4) {
      nar.push(hotgame.slice(i, i + 4))
    }

    return nar
  }
  let newarr = res(hotgame || [])

  /* 获得取整数字 */

  /* 跳转详情页 */
  //   const goDetails = (para) => {
  //     window.location = "/page/details?gid=" + para;
  //   };

  return (
    <div className="hot-banner">
      {/* banner */}

      <Carousel autoplay autoplaySpeed={3000} dotPosition dots>
        {newarr?.map(item => (
          <div key={item}>
            <div className="banner-box">
              <ul>
                {item?.map((item, i) => (
                  <li key={item.gid}>
                    <a href={'/page/details?gid=' + item.gid} className="dis_a">
                      <img src={backbg[i]} alt="" className="backbg" />
                      <div className="hot-top">
                        <img src={process.env.REACT_APP_BASEURL + item.icon} alt="" />
                        <div>
                          <p>{getNum(item.count)}</p>
                          <span>
                            {starsScore(item.score)} {item.score}
                          </span>
                        </div>
                      </div>
                    </a>

                    <h3>{item.name}</h3>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  )
}
